import { CellProps, Column } from 'react-table';
import clsx from 'clsx';
import _ from 'lodash-es';

import { DefaultFilter } from '@/core/components/datatables/components/Filter';
import type {
  DockerContainer,
  DockerContainerStatus,
} from '@/docker/containers/types';

/**
 * Состояния контейнера в терминах Docker и их отображение в интерфейсе.
 * Исходное значение (`DockerContainer.Status`) не переводится: оно используется
 * в логике доступности действий над контейнером.
 */
const STATE_LABELS: Record<DockerContainerStatus, string> = {
  paused: 'Приостановлен',
  stopped: 'Остановлен',
  created: 'Создан',
  healthy: 'Работает (проверка пройдена)',
  unhealthy: 'Работает (проверка не пройдена)',
  starting: 'Запускается',
  running: 'Работает',
  dead: 'Не работает',
  exited: 'Завершён',
};

export function stateLabel(status: DockerContainerStatus) {
  return STATE_LABELS[status] || status;
}

export const state: Column<DockerContainer> = {
  Header: 'Состояние',
  accessor: (row) => stateLabel(row.Status),
  id: 'state',
  Cell: StatusCell,
  sortType: 'string',
  filter: 'multiple',
  Filter: DefaultFilter,
  canHide: true,
};

function StatusCell({
  row: { original: container },
}: CellProps<DockerContainer>) {
  const status = container.Status;
  const statusNormalized = _.toLower(status);
  const hasHealthCheck = ['starting', 'healthy', 'unhealthy'].includes(
    statusNormalized
  );

  const statusClassName = getClassName();

  return (
    <span
      className={clsx('label', `label-${statusClassName}`, {
        interactive: hasHealthCheck,
      })}
      title={
        hasHealthCheck
          ? 'Для контейнера настроена проверка работоспособности'
          : ''
      }
    >
      {stateLabel(status)}
    </span>
  );

  function getClassName() {
    if (includeString(['paused', 'starting', 'unhealthy'])) {
      return 'warning';
    }

    if (includeString(['created'])) {
      return 'info';
    }

    if (includeString(['stopped', 'dead', 'exited'])) {
      return 'danger';
    }

    return 'success';

    function includeString(values: DockerContainerStatus[]) {
      return values.some((val) => statusNormalized.includes(val));
    }
  }
}
